import { CustomElement } from "../../../core/CustomElement";

// Components.
import "../../loader/index";
import { CCCLoader } from "../../loader/index";

export class CCCButton extends CustomElement {
  //state: Object = { foo: "bar" };
  loader: CCCLoader = null;
  component: CCCButton = null;

  static get observedAttributes(): Array<string> {
    return ["text", "size", "type", "disabled", "block", "loading"];
  }

  constructor() {
    super();
    this.templateConfig = {
      template: require("./template.html").default,
      style: require("./style.scss").default,
    };
    this.setupComponent();
    this.component = this.shadowDom.querySelector("#ccc-button");
    this.loader = this.shadowDom.querySelector(".ccc-button-loader");
    this.listenToClick();
  }

  attributeChangedCallback(
    attr: string,
    oldValue: string,
    newValue: string
  ): void {
    if (attr == "text") {
      // @ts-ignore
      this.shadowDom.querySelector(".ccc-button-text").innerText = newValue;
    }

    if (attr == "size") {
      this.addRemoveClasses(["large", "small"], newValue);
    }

    if (attr == "type") {
      this.addRemoveClasses(
        ["cta", "outline", "borderless", "danger"],
        newValue
      );
    }

    if (attr == "disabled") {
      if (newValue === null) {
        this.component.removeAttribute("disabled");
      } else {
        this.component.setAttribute("disabled", "");
      }
    }

    if (attr == "block") {
      if (newValue === "true") {
        this.component.classList.add("block");
      } else {
        this.component.classList.remove("block");
      }
    }

    if (attr === "loading") {
      if (newValue === null) {
        this.component.removeAttribute("disabled");
        this.loader.classList.remove("display");
      } else {
        this.component.setAttribute("disabled", "");
        this.loader.classList.add("display");
      }
    }
  }

  protected addRemoveClasses(classes: string[], newVal: string): void {
    classes.forEach((clss) => {
      this.component.classList.remove(clss);
    });

    if (classes.indexOf(newVal) > -1) {
      this.component.classList.add(newVal);
    }
  }

  listenToClick(): void {
    this.component.addEventListener("click", () => {
      const event = new Event("ccc-button-click");
      this.dispatchEvent(event);
    });
  }
}

// define component
if (!customElements.get("ccc-button")) {
  customElements.define("ccc-button", CCCButton);
}
